import { Tooltip, TooltipProps } from 'antd';
import { FC, ReactNode } from 'react';

import styles from './IssueColumnHeader.module.scss';

interface IssueColumnHeaderProps {
  children: ReactNode;
  tooltip?: string;
  tooltipPlacement?: TooltipProps['placement'];
  sticky?: boolean;
}

const IssueColumnHeader: FC<IssueColumnHeaderProps> = ({
  children,
  tooltip,
  tooltipPlacement = 'topLeft',
  sticky = true,
}) => {
  const className = sticky ? `${styles.columnHeader} ${styles.sticky}` : styles.columnHeader;
  const header = <div className={className}>{children}</div>;

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement={tooltipPlacement}>
        {header}
      </Tooltip>
    );
  }

  return header;
};

export default IssueColumnHeader;
